import { mapSagasFromConfigurations } from '../../helpers/sagas';
import { configurations } from './configurations';

function* systemStatusSagas() {
  yield mapSagasFromConfigurations('systemStatus')(configurations)
}

export default systemStatusSagas;



// WEBPACK FOOTER //
// ./src/state/modules/system-status/sagas.js